module.exports = __webpack_public_path__ + "img/main_mobile.5044ca85.jpg";